import React from "react";
import { useTranslation } from "react-i18next";
import { ICellRendererParams } from "@ag-grid-community/core";

import { formatTransactionNumber } from "../../../../helpers/format";
import { GridTransaction } from "../../../../types";

import TwoLineGridCell from "../TwoLineGridCell";
import { InvoiceLink } from "../../..";

interface Props extends ICellRendererParams {
  data: GridTransaction;
}

const TransactionNumberRenderer = ({ data }: Props) => {
  const { t } = useTranslation();
  const secondLineData = (
    <InvoiceLink
      invoiceNumber={data.invoiceNumber}
      prefix={t("invoices.linkPrefixShort")}
    />
  );

  return (
    <TwoLineGridCell
      firstLineData={formatTransactionNumber(data.transactionNumber, "")}
      secondLineData={secondLineData}
    />
  );
};

export default TransactionNumberRenderer;
